
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $662b95881c2ea177$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"37GuQ\",\"bi_quyet_giup_con_het_nghien_game_tu_chuyen_gia_Nguyen_Thi_Lanh.e6a20996.js\",\"lfPIM\",\"img_new_1.80b50e8d.jpg\",\"hBBkI\",\"img_new_2.63e87f79.jpg\",\"gLHZK\",\"img_new_3.0d2b4bfa.jpg\",\"bf2pj\",\"img_new_4.1fffc383.jpg\",\"9hN0F\",\"img_new_10.08d82a3b.jpg\",\"2sOik\",\"img_new_6.daa04857.jpg\",\"8h7Aq\",\"img_new_7.6d5f5918.jpg\",\"hxPPl\",\"img_new_8.a251a5d9.jpg\"]"));

var $5bd7aea7ae3863dc$exports = {};
$5bd7aea7ae3863dc$exports = new URL("img_new_1.80b50e8d.jpg", import.meta.url).toString();


var $51bf8b37346ca861$exports = {};
$51bf8b37346ca861$exports = new URL("img_new_2.63e87f79.jpg", import.meta.url).toString();


var $24958703ea0b853c$exports = {};
$24958703ea0b853c$exports = new URL("img_new_3.0d2b4bfa.jpg", import.meta.url).toString();


var $8f47ed4fd09ee24c$exports = {};
$8f47ed4fd09ee24c$exports = new URL("img_new_4.1fffc383.jpg", import.meta.url).toString();


var $c76ac350492d7a1f$exports = {};
$c76ac350492d7a1f$exports = new URL("img_new_10.08d82a3b.jpg", import.meta.url).toString();


var $5ed172ac6791614b$exports = {};
$5ed172ac6791614b$exports = new URL("img_new_6.daa04857.jpg", import.meta.url).toString();


var $d8e80a61f8593ba9$exports = {};
$d8e80a61f8593ba9$exports = new URL("img_new_7.6d5f5918.jpg", import.meta.url).toString();


var $014bdb8f1ca26436$exports = {};
$014bdb8f1ca26436$exports = new URL("img_new_8.a251a5d9.jpg", import.meta.url).toString();


const $ade342ca4d253c6c$var$listEvent = document.querySelectorAll(".item-benefit");
const $ade342ca4d253c6c$var$imgEvent = document.getElementById("image_event");
const $ade342ca4d253c6c$var$imageSources = [
    (0, (/*@__PURE__*/$parcel$interopDefault($5bd7aea7ae3863dc$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($51bf8b37346ca861$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($24958703ea0b853c$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($8f47ed4fd09ee24c$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($c76ac350492d7a1f$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($5ed172ac6791614b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($d8e80a61f8593ba9$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($014bdb8f1ca26436$exports)))
];
$ade342ca4d253c6c$var$listEvent.forEach((item, index)=>{
    item.addEventListener("mouseenter", ()=>{
        if ($ade342ca4d253c6c$var$imgEvent && $ade342ca4d253c6c$var$imageSources[index]) $ade342ca4d253c6c$var$imgEvent.src = $ade342ca4d253c6c$var$imageSources[index];
    });
});


//# sourceMappingURL=bi_quyet_giup_con_het_nghien_game_tu_chuyen_gia_Nguyen_Thi_Lanh.e6a20996.js.map
